import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpPostService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';
import { AxiosResponse } from 'axios';

import ICreateReminderCommand from '../../../Common/types/Commands/ICreateReminderCommand';

export const createReminder = createAsyncThunk('Reminder/createReminder', async (command: ICreateReminderCommand) => {
  return await BasicInfoHttpPostService({
    url: `${_apiPathManagerConfig?.BasicInfo.Reminder.CreateReminder}`,
    body: command,

    onResult: (res: AxiosResponse<any, any>): any => {
      return res;
    },
  });
});
